import { ConfirmModal } from '../../../shared/modal'
import { Switch } from '../../../shared/input'

export type ConfirmReadOnlyBulkActionModalProps = {
  /** Determines visibility of modal */
  isOpen: boolean
  /** Event callback when Confirm Button is triggered */
  onConfirm: () => void
  /** Whether to set plans as read-only (true) or editable (false) */
  readOnlyForStudents: boolean
  /** Callback to toggle the readOnlyForStudents value */
  onToggleReadOnly: (value: boolean) => void
}

const ConfirmReadOnlyBulkActionModal = ({
  isOpen,
  onConfirm,
  readOnlyForStudents,
  onToggleReadOnly
}: ConfirmReadOnlyBulkActionModalProps) => (
  <ConfirmModal
    confirmText={readOnlyForStudents ? 'Set Read-Only' : 'Set Editable'}
    isOpen={isOpen}
    onConfirm={onConfirm}
    title={
      readOnlyForStudents
        ? 'Set All Student Plans to Read-Only'
        : 'Set All Student Plans to Editable'
    }
  >
    <div style={{ marginBottom: 16 }}>
      <Switch
        ariaLabel="Toggle read-only for students"
        id="readOnlyForStudents"
        label="Read-Only for Students"
        checked={readOnlyForStudents}
        onChange={() => onToggleReadOnly(!readOnlyForStudents)}
      />
    </div>
    {readOnlyForStudents ? (
      <>
        Are you sure you want to set all student plans to read-only?
        <p>
          This action will prevent students from editing their plans. Advisors and administrators
          can still toggle individual plans back to editable.
        </p>
      </>
    ) : (
      <>
        Are you sure you want to set all student plans to editable?
        <p>This action will allow students to edit their plans.</p>
      </>
    )}
    <p>
      <strong>Note:</strong> This operation affects all student plans and may take several minutes
      to complete. You can monitor the progress after confirming.
    </p>
  </ConfirmModal>
)

export default ConfirmReadOnlyBulkActionModal
